import React, { useEffect, useMemo } from 'react';
import { AppStore, AppDataContext } from './Context';
import { ServerBuilder } from '../server/config';
import { useNavigate } from 'react-router-dom';

export const AppDataProvider = ({ children }) => {
    const userLoggedIn = Boolean(localStorage.token);
    const navigate = useNavigate();
    const updateAlert = (message, type, status) => {
        store.update({
            alertError: {
                message,
                type,
                status
            }
        });
    };

    const initialState = {
        permissions: {},
        actions: {},
        controllersData: {},
        userInfo: {},
        images: {},
        alertError: { message: '', type: 'snackbar', status: 'error' },
        server: new ServerBuilder({
            updateAlertError: updateAlert,
            navigate
        }).build()
    };

    const store = useMemo(() => new AppStore(initialState), []);

    const fetchServerData = async (serverRequest) => {
        const metaData = await serverRequest.users.metaInfo();

        const { permissions, currentUser, actionPermissions } = metaData;

        store.update({
            permissions: permissions || {},
            actions: actionPermissions || {},
            userInfo: {
                ...currentUser
            },
        });
    };

    const resetStore = () => {
        store.update({
            permissions: {},
            actions: {},
            controllersData: {},
            userInfo: {},
            images: {},
            alertError: { message: '', type: 'snackbar', status: 'error' }
        });
    };
    useEffect(() => {
        if (userLoggedIn && store.getState().server) {
            fetchServerData(store.getState().server);
        } else {
            resetStore();
        }
    }, [userLoggedIn, store]);


    return (
        <AppDataContext.Provider value={store}>
            {children}
        </AppDataContext.Provider>
    );
};
